var _rect, _rect2, _rect3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPasswordHash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 38,
    viewBox: "0 0 48 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 35.5,
    rx: 5,
    fill: "white",
    stroke: "#4B4A50",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 3.75,
    width: 40.5,
    height: 24.75,
    rx: 3,
    fill: "#FFEFF0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.25,
    y: 30.75,
    width: 13.5,
    height: 2.25,
    rx: 1.125,
    fill: "#4B4A50"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 14.25H27V10.875V10.5C27 8.84315 25.6569 7.5 24 7.5C22.3431 7.5 21 8.84315 21 10.5V14.25Z",
    stroke: "#4B4A50",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 12.75,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#FFEFF0",
    stroke: "#4B4A50",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7264 19.3127C25.1877 19.0568 25.5 18.5649 25.5 18C25.5 17.1716 24.8284 16.5 24 16.5C23.1716 16.5 22.5 17.1716 22.5 18C22.5 18.5649 22.8123 19.0568 23.2736 19.3127C23.2582 19.3726 23.25 19.4353 23.25 19.5V21C23.25 21.4142 23.5858 21.75 24 21.75C24.4142 21.75 24.75 21.4142 24.75 21V19.5C24.75 19.4353 24.7418 19.3726 24.7264 19.3127Z",
    fill: "#4B4A50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5,
    height: 18.75,
    fill: "white",
    transform: "translate(17.25 6.75)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPasswordHash);
export default __webpack_public_path__ + "static/media/icon-password-hash.6d593a7d3eb31c06b48d4d675e009ddc.svg";
export { ForwardRef as ReactComponent };